const CERTIFICATE_FILE_EXTENSION = /\.(?:zip|pem|crt|cer|key)$/i

export function certificateUploadFiles(files: Iterable<File>): File[] {
  return Array.from(files).filter((file) => CERTIFICATE_FILE_EXTENSION.test(file.name))
}
